import { DRAWER, PRIMARY_COLOR, EDITING_COLOR, LOADING } from './types';

export default {
  drawer: state => state[DRAWER],
  primaryColor: state => state[PRIMARY_COLOR],
  editingColor: state => state[EDITING_COLOR],
  loading: state => state[LOADING],
};
